import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-page-body',
  templateUrl: './page-body.component.html',
  styleUrls: ['./page-body.component.scss']
})
export class MmPageBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
